import * as React from "react";
import { Link } from "react-router-dom";

export const NotFound: React.FC = () => {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center bg-ivory px-6 text-center"
      data-testid="not-found"
    >
      <span className="mb-6 block h-px w-12 bg-brass" />
      <h1 className="font-serif text-3xl text-charcoal md:text-4xl">
        This link isn't available.
      </h1>
      <p className="mt-4 max-w-md text-base leading-relaxed text-charcoal-soft">
        The presentation you're looking for may have expired or the link may be
        incomplete. If you were sent this by your agent, please reach out to them
        directly.
      </p>
      <Link
        to="/demo"
        className="mt-8 text-xs uppercase tracking-[0.2em] text-charcoal-muted underline-offset-4 hover:text-charcoal hover:underline"
      >
        Internal demo
      </Link>
    </div>
  );
};

export default NotFound;
